import { getProductCategories } from "@hardware/Services/CustomProductService";
import { setGA4Event } from "@hardware/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchLoadPromotions } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";

addToChainAfter(chain, DispatchLoadPromotions, async props => {
    // Verndale Custom
    const state = props.getState();

    const cartLines = props.apiResult.cart.cartLines || [];

    if (cartLines.length === 0) {
        return;
    }

    const result = await getProductCategories({
        productIds: [...cartLines.map(cl => cl.productId!)],
        type: "product",
    });

    if (result.successful) {
        const productProperties = result.result.productProperties;
        const currentPath = window.location.pathname;
        if (currentPath === "/Cart") {
            setGA4Event("view_cart", cartLines, {
                productProperties,
            });
        }
    }
});
